module.exports = __webpack_public_path__ + "img/giants.71dac05e.svg";